import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full pt-4 pb-28 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative" data-id="element-139">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-140">
        <div className="text-brand-gold font-bold tracking-widest text-sm mb-6 uppercase flex items-center gap-2" data-id="element-141">
          <span className="text-base" style={{
          fontFamily: 'serif'
        }} data-id="element-142">
            ∞
          </span>
          Infinitamente digital
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-143">
            <path d="M12 2a5 5 0 0 1 4.9 4 4.5 4.5 0 0 1 2.1 3.8 4.5 4.5 0 0 1-1.5 3.4A4 4 0 0 1 16 17h-1v5h-6v-5H8a4 4 0 0 1-1.5-3.8A4.5 4.5 0 0 1 5 9.8 4.5 4.5 0 0 1 7.1 6 5 5 0 0 1 12 2z" data-id="element-144" />
            <path d="M12 2v8" data-id="element-145" />
            <path d="M8 10h8" data-id="element-146" />
          </svg>
        </div>

        <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold text-white leading-tight mb-10 tracking-tight max-w-4xl" data-id="element-147">
          Salí del Veraz <span className="text-brand-gold" data-id="element-148">hoy.</span>
        </h1>

        <div className="relative w-full max-w-3xl mx-auto mb-2" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/7j3Ph5K36bsF5d4JrdroWp/546a551b-e152-4131-bba5-4be40f4e375b.png" alt="Mega Pack Protocolo Salir del Veraz" className="w-full h-auto object-contain drop-shadow-2xl mt-[-80px] mb-[-80px]" data-id="element-150" />
          <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.4,
          type: 'spring',
          stiffness: 200
        }} className="absolute -top-2 -right-2 sm:top-0 sm:-right-4 rounded-full flex flex-col items-center justify-center z-10" style={{
          background: 'radial-gradient(circle at 30% 30%, #e8d48b, #c9a84c 40%, #8b6914 100%)',
          boxShadow: '0 0 15px rgba(201,168,76,0.4), 0 0 30px rgba(201,168,76,0.15), inset 0 1px 1px rgba(255,255,255,0.3)',
          border: '1.5px solid rgba(232,212,139,0.5)',
          width: '4rem',
          height: '4rem'
        }} data-id="element-151">
            <span className="text-black font-extrabold text-sm sm:text-base leading-none drop-shadow-sm" data-id="element-152">
              +6
            </span>
            <span className="text-black/80 font-bold text-[7px] sm:text-[8px] leading-tight text-center uppercase tracking-wider" data-id="element-153">
              Bonos
              <br data-id="element-154" />
              Exclusivos
            </span>
          </motion.div>
        </div>

        <p className="text-xl sm:text-2xl md:text-3xl text-brand-gold font-bold mb-4 -mt-16" data-id="element-155">
          La ley 25.326 ya está de tu lado.
        </p>

        <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl mb-12" data-id="element-156">
          Limpiá tu historial y recuperá tu crédito. Sin abogados. Sin pagar.
        </p>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-2 bg-green-500 text-white font-extrabold text-lg sm:text-xl px-10 py-4 rounded-full shadow-[0_0_25px_rgba(34,197,94,0.4)] hover:shadow-[0_0_35px_rgba(34,197,94,0.6)] hover:bg-green-600 hover:scale-105 transition-all duration-200 uppercase tracking-wide" data-id="element-157">
          Quiero salir del Veraz
        </motion.a>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 text-[10px] sm:text-xs text-gray-400 font-normal" data-id="element-158">
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-159">
            <span className="text-[10px]" data-id="element-160">📄</span> 100% PDF
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-161">
            <span className="text-[10px]" data-id="element-162">⚡</span> Acceso inmediato
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-163">
            <span className="text-[10px]" data-id="element-164">🛡️</span> Garantía 7 días
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-165">
            <span className="text-[10px]" data-id="element-166">💳</span> Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}